export default __webpack_public_path__ + "static/media/Refin_Osmos_Tortora 80x80_Out.21cb7e26.jpg";